export default "__VITE_ASSET__DmT7nsP7__"